import { useCallback, useEffect, useRef } from 'react';
import { useRefCallback } from '../../../callback/ref-callback';
export function useTimeout(duration, handler) {
  var handlerCallback = useRefCallback(handler);
  var timerRef = useRef(null);
  var setup = useCallback(function (timeout) {
    var timerHandler = function timerHandler() {
      timerRef.current = null;
      handlerCallback();
    };

    timerRef.current = setTimeout(timerHandler, timeout);
  }, []);
  var teardown = useCallback(function () {
    if (timerRef.current == null) {
      return;
    }

    clearTimeout(timerRef.current);
    timerRef.current = null;
  }, []);
  useEffect(function () {
    if (duration === 0) {
      return;
    }

    setup(duration);
    return teardown;
  }, [duration]);
  return teardown;
}